import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { adminLogin, adminMe } from "@/lib/api";

const AdminAuthContext = createContext(null);
const TOKEN_KEY = "beh_admin_token";

export function AdminAuthProvider({ children }) {
  const [username, setUsername] = useState(null);
  const [loading, setLoading] = useState(true);

  const verify = useCallback(async () => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (!token) {
      setUsername(null);
      setLoading(false);
      return;
    }
    try {
      const me = await adminMe();
      setUsername(me.username);
    } catch (e) {
      localStorage.removeItem(TOKEN_KEY);
      setUsername(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    verify();
  }, [verify]);

  const login = async (user, pass) => {
    const res = await adminLogin(user, pass);
    localStorage.setItem(TOKEN_KEY, res.access_token);
    setUsername(res.username);
    return res;
  };

  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUsername(null);
  };

  return (
    <AdminAuthContext.Provider value={{ username, loading, login, logout, isAuthenticated: !!username }}>
      {children}
    </AdminAuthContext.Provider>
  );
}

export function useAdminAuth() {
  const ctx = useContext(AdminAuthContext);
  if (!ctx) throw new Error("useAdminAuth must be used within AdminAuthProvider");
  return ctx;
}
